<div class="task-outer-container">
  <div class="task-flag-cell">
    <span *ngIf="task.paymentRelated" class="flag-check">✓</span>
  </div>
  <div class="task-flag-cell">
    <span *ngIf="task.creatorFacing" class="flag-check">✓</span>
  </div>

  <div class="task-container" (click)="taskClicked()">
    <div>
      <div class="description">
        <div>{{task.description}} <span *ngIf="!task.dueToday">({{task.dueDateString}})</span><span *ngIf="task.campaignId" class="campaign-link" [routerLink]="['/agent/campaigns', task.campaignId]" >Link</span></div>
      </div>
      <div class="campaign-name">{{task.campaignName}} ({{task.creatorName}})</div>
    </div>
  </div>

  <div class="right-side-container">
    <div *ngIf="task.pastDue" class="past-due">Past Due</div>
    <div *ngIf="task.dueToday" class="past-due">Today</div>
    <img *ngIf="!showDeleteSpinner" (click)="deleteTask()" src="delete_icon.svg" alt="Delete Invoice" width="20" height="20">
    <span *ngIf="showDeleteSpinner" class="loader-small"></span>
  </div>
</div>

<app-dialog [(visible)]="showTaskDialog" >
  <ng-container *ngIf="task">
    <h3>{{task.campaignName}}</h3>


    <div class="task-input-row">
      <span>Task Description:</span>
      <span><input class="input-style" type="text" [ngModel]="task!.description" (ngModelChange)="onDescriptionChange($event)"/></span>
    </div>


    <div class="task-input-row">
      <span>Due Date</span>
      <span><input class="input-style" type="date" [ngModel]="task!.dueDate" (ngModelChange)="onDueDateChange($event)"/></span>
    </div>


    <div class="task-input-row">
      <span>Complete?</span>
      <span><input type="checkbox" [ngModel]="task!.complete" (ngModelChange)="onCompleteChange($event)"/></span>
    </div>

    <div class="task-input-row">
      <span>Payment Related Task: </span>
      <span><input type="checkbox" [ngModel]="task.paymentRelated" (ngModelChange)="onPaymentRelatedChange($event)"/></span>
    </div>

    <div class="task-input-row">
      <span>Creator Facing: </span>
      <span><input type="checkbox" [ngModel]="task.creatorFacing" (ngModelChange)="onCreatorFacingChange($event)"/></span>
    </div>

    <div class="button-container">
      <button class="button-style" (click)="showTaskDialog = false;">Close</button>
    </div>
  </ng-container>
</app-dialog>

